<script setup>
import { computed } from 'vue';
import {
  messageTimestamp,
  messageTimestampSmart,
} from 'shared/helpers/timeHelper';
import { useMessageContext } from '../provider.js';
import { useMessageSender } from '../useMessageSender.js';

/**
 * Bloom: inline meta header (no avatar — the wrapping bubble provides
 * one in its left column). Renders the "name + Internal pill +
 * timestamp" row at the top of private notes / threaded comments,
 * mirroring Front.
 */
const { createdAt, isPrivate } = useMessageContext();
const { name: senderName } = useMessageSender();

const shortTime = computed(() => messageTimestampSmart(createdAt.value));
const absoluteTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, yyyy h:mm a')
);
const isoTime = computed(() =>
  createdAt.value ? new Date(createdAt.value * 1000).toISOString() : ''
);
</script>

<template>
  <header class="flex items-baseline gap-2">
    <span class="font-semibold text-n-slate-12 truncate">
      {{ senderName }}
    </span>
    <span
      v-if="isPrivate"
      class="text-[10px] uppercase tracking-wide font-semibold px-1.5 py-px rounded text-n-amber-11 bg-n-amber-3"
    >
      {{ $t('CONVERSATION.INTERNAL') }}
    </span>
    <time
      v-tooltip.left="absoluteTime"
      :datetime="isoTime"
      class="shrink-0 ml-auto text-xs text-n-slate-10 whitespace-nowrap"
    >
      {{ shortTime }}
    </time>
  </header>
</template>
